import {
    Component,
    Input,
    OnDestroy,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { RadiobuttonGroupComponent } from "@components/radiobuttongroup/radiobuttongroup.component";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { IRadiobuttonItem } from "~app/common/components/radiobuttongroup/radiobutton/IRadiobuttonItem";
import { TradslagKalkylMetod } from "~app/features/virkeskop/models/tradslag/tradslag-models";
import { AtgardMediatorService } from "~app/features/virkeskop/services/atgard-mediator.service";
import { TradslagMediatorHandlerService } from "~app/features/virkeskop/services/tradslag-mediator-handler.service";
import { TradslagMediatorService } from "../../../services/tradslag-mediator.service";
import { ForkalkylDirektutbyteComponent } from "../forkalkyl-direktutbyte/forkalkyl-direktutbyte.component";
import { ForkalkylSnabbkalkylComponent } from "../forkalkyl-snabbkalkyl/forkalkyl-snabbkalkyl.component";
import { TradslagMallComponent } from "../tradslag-mall/tradslag-mall.component";

@Component({
    selector: "rask-forkalkyl-tradslag",
    templateUrl: "./forkalkyl-tradslag.component.html",
    styleUrls: ["./forkalkyl-tradslag.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TradslagMallComponent,
        RadiobuttonGroupComponent,
        ForkalkylSnabbkalkylComponent,
        ForkalkylDirektutbyteComponent
    ]
})
export class ForkalkylTradslagComponent implements OnInit, OnDestroy {
    @Input() kontraktReadonly = false;

    protected readonly tradslagMediatorService = inject(TradslagMediatorService);

    protected kalkylmetodButtons: IRadiobuttonItem[] = [
        { key: "snabbkalkyl",
            value: "Snabbkalkyl" },
        { key: "direktutbyte",
            value: "Direktutbyte" }
    ];
    protected loaded = false;

    private readonly atgardMediatorService = inject(AtgardMediatorService);
    private readonly ngUnsubscribe$ = new Subject<void>();
    private readonly tradslagMediatorHandlerService = inject(TradslagMediatorHandlerService);

    protected get activeKalkylmetod() {
        return this.tradslagMediatorService.kalkylmetod;
    }

    protected get isSnabbkalkylActive() {
        return this.activeKalkylmetod === "snabbkalkyl";
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    ngOnInit(): void {
        const atgard = this.atgardMediatorService.atgard;

        // Gör att vi får en ny instans med värden från db om vi navigerar mellan nya /gamla, kan tas bort i samband med gamla VK.
        if(atgard?.guid) {
            this.tradslagMediatorHandlerService.remove(atgard.guid);
        }

        this.loaded = true;

        this.tradslagMediatorService.calculatedMedelstam$
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(value =>
                this.atgardMediatorService.calculatedMedelstam$.next(value));
    }

    protected kalkylmetodChange(value: TradslagKalkylMetod) {
        this.tradslagMediatorService.changeKalkylmetod(value);
    }
}
